import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { isEnabled, findAll, disableElement, enableElement } from '@fretadao/f-js-dom';
import { isBlank, isEmptyArray } from '@fretadao/f-js-utils';

application.register(
  'enable-submit',
  class extends Controller {
    static targets = ['form', 'button', 'checkboxField'];
    static classes = ['disable'];
    static values = {
      blankFieldsSelector: {
        type: String,
        default: '[required]'
      }
    };

    connect() {
      this.check_filled_fields();
      this.element.addEventListener('enable-submit:check', this.check_filled_fields.bind(this));
    }

    disconnect() {
      this.element.removeEventListener('enable-submit:check');
    }

    check_filled_fields() {
      const buttonAction = this.#someBlankField() ? disableElement : enableElement;

      buttonAction(this.buttonTarget);
    }

    #someBlankField() {
      return !isEmptyArray(this.#blankFieldsFor([this.blankFieldsSelectorValue])) || this.#isAllCheckboxFieldsBlank();
    }

    #blankFieldsFor(selectors) {
      return selectors
        .flatMap(
          selector => findAll(selector, this.formTarget)
          .filter((field) => isBlank(field.value) && isEnabled(field))
        );
    }

    #isAllCheckboxFieldsBlank() {
      return this.hasCheckboxFieldTarget && this.checkboxFieldTargets.every(checkbox => isBlank(checkbox.checked));
    }
  }
);
